import { useState, useEffect } from "react";
import PopUp from "../../styles/PopUp";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { isCreateProfilePopState } from "../../../recoil/contentsAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  checkProfileNameApi,
  uploadUserImgApi
} from "../../../api/userInfoApi";
import {
  headersState,
  isProfileCreatedState,
  userNicknameState,
  userProfileImgState,
  userProfileKeyState
} from "../../../recoil/userInfoAtom";
import { BASE_PATH } from "../../../api/commonApi";
import WrapLoading from "../../common/loading/WrapLoading";
import { allowedTypes } from "../common/popPageCommonFunc/CommonFunc";
import "./CreateProfilePopUp.scoped.scss";

function OptionTitle(props: { option: string; isEssential: boolean }) {
  return (
    <span>
      {props.option} <p>({props.isEssential ? "필수" : "선택"})</p>
    </span>
  );
}

function ValidTxt(props: { text: string }) {
  return (
    <div className="txt">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10 1H2C1.45 1 1.005 1.45 1.005 2L1 11L3 9H10C10.55 9 11 8.55 11 8V2C11 1.45 10.55 1 10 1ZM6.5 5.5H5.5V2.5H6.5V5.5ZM6.5 7.5H5.5V6.5H6.5V7.5Z"
          fill="#5BCAE6"
        />
      </svg>
      <div>{props.text}</div>
    </div>
  );
}

interface IProps {
  type: number;
  data?: {
    profile: string;
    profile_background: string;
    desc: string;
    nickname: string;
  };
}

function CreateProfilePopUp(props: IProps) {
  const userProfileKey = useRecoilValue(userProfileKeyState);
  const headers = useRecoilValue(headersState);
  const [inputValue, setInputValue] = useState<{
    nickName: string;
    desc: string;
  }>({
    nickName: "",
    desc: ""
  });
  const [isValid, setIsValid] = useState<{
    isSave: boolean;
    passNickname: boolean;
  }>({ isSave: false, passNickname: false });
  const [userNickName, setUserNickName] = useRecoilState(userNicknameState);
  const [isNicknameLoading, setIsNicknameLoading] = useState(false);
  const [isuploadLoading, setIsuploadLoading] = useState(false);
  const [imgBase64, setImgBase64] = useState<{
    profile: string;
    profile_background: string;
  }>({ profile: "", profile_background: "" });
  const [imgFile, setImgFile] = useState<{
    profile: FileList | null;
    profile_background: FileList | null;
  }>({ profile: null, profile_background: null });
  let url: {
    [key: string]: string;
  } = { profile: "", profile_background: "" };
  const navigate = useNavigate();
  const setIsCreateProfilePop = useSetRecoilState(isCreateProfilePopState);
  const setIsProfileCreated = useSetRecoilState(isProfileCreatedState);
  const setUserProfileImg = useSetRecoilState(userProfileImgState);

  const onValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
  };

  useEffect(() => {
    setInputValue({ ...inputValue, nickName: userNickName });

    if (props.type === 1) {
      setInputValue({
        nickName: props.data?.nickname || "",
        desc: props.data?.desc || ""
      });
      setImgBase64({
        profile: props.data?.profile || "",
        profile_background: props.data?.profile_background || ""
      });
    }
  }, [props]);

  // 아래 코드 이유 찾기
  // useEffect(() => {
  //   if (imgBase64.profile === "") {
  //     setImgFile({ ...imgFile, profile: null });
  //   }

  //   if (imgBase64.profile_background === "") {
  //     setImgFile({ ...imgFile, profile_background: null });
  //   }
  // }, [imgBase64]);

  useEffect(() => {
    setIsValid({ ...isValid, isSave: inputValue.nickName.length !== 0 });
  }, [inputValue.nickName]);

  const handleAddImg = (e: React.ChangeEvent<HTMLInputElement>) => {
    let uploadFile: FileList | null = e.target.files;
    const { name } = e.target;
    setImgFile({ ...imgFile, [name]: uploadFile });
    setImgBase64({ profile: "", profile_background: "" });

    let file = e.target.files!;
    if (file[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onloadend = () => {
        const base64 = reader.result;
        if (base64) {
          let base64Sub = base64.toString();
          setImgBase64({ ...imgBase64, [name]: base64Sub });
        }
      };
    }
  };

  const onClickNickNameCheckBtn = async () => {
    if (inputValue.nickName.length === 0) {
      alert("닉네임을 입력해주세요");
      return;
    }

    if (inputValue.nickName.length > 12) {
      alert("닉네임은 12자 이내로 설정해야합니다");
      return;
    }

    setIsNicknameLoading(true);

    try {
      await axios
        .get(checkProfileNameApi(inputValue.nickName), {
          headers: {
            ...headers
          }
        })
        .then((res) => {
          if (res.data.result === 1) {
            setIsValid({ ...isValid, passNickname: true });
          } else if (res.data.result === -96) {
            alert("이미 존재하는 닉네임입니다");
          } else {
            alert("잠시후 다시 시도해주세요");
          }
        });
    } catch (error) {
      console.log(error, "profile nickname check");
    } finally {
      setIsNicknameLoading(false);
    }
  };

  const uploadImg = async (type: string) => {
    let typeImgFile =
      type === "profile" ? imgFile.profile : imgFile.profile_background;

    let img =
      type === "profile" ? imgBase64.profile : imgBase64.profile_background;

    if (img.split(":")[0] !== "http" || img.split(":")[0] !== "https") {
      if (typeImgFile !== null) {
        setIsuploadLoading(true);
        try {
          await axios
            .post(
              uploadUserImgApi(userProfileKey),
              {
                type: type,
                form_name: type,
                [type]: typeImgFile[0]
              },
              { headers: { "Content-Type": "multipart/form-data" } }
            )
            .then((res) => {
              const result = res.data.result;
              if (result === 1 || result === -91) {
                url[type] = res.data.data.url;
              } else if (result === -94) {
                alert("용량 초과");
              } else if (result === -93) {
                alert("허용되지 않는 파일 타입");
              } else {
                alert("다시 시도해주세요//");
              }
            });
        } catch (error) {
          console.log(error, "img upload");
        } finally {
          setIsuploadLoading(false);
        }
      }
    }
  };

  const uploadInfo = async () => {
    if (inputValue.nickName.length === 0) {
      alert("닉네임은 필수 입력입니다");
      return;
    }

    if (!isValid.passNickname) {
      alert("닉네임 중복 확인을 해주세요");
      return;
    }

    if (props.type === 2) {
      try {
        await axios
          .post(
            `${BASE_PATH}/api/vfunlounge/profile`,
            {
              user_profile_key: userProfileKey,
              user_nick_name: inputValue.nickName,
              user_profile_image_url: url.profile,
              user_profile_background_image_url: url.profile_background,
              user_profile_desc: inputValue.desc
            },
            {
              headers: {
                ...headers
              }
            }
          )
          .then((res) => {
            if (res.data.result === 1) {
              alert("마이 프로필이 생성되었습니다.");
              setIsCreateProfilePop(false);
              setIsProfileCreated(true);
              setUserNickName(inputValue.nickName);
              setUserProfileImg(url.profile);
              // 확인 필요
              navigate(`/profile/${userProfileKey}/post`);
            } else {
              alert("다시 시도해주세요sss");
            }
          });
      } catch (error) {
        console.log(error, "profileApi");
      }
    } else if (props.type === 1) {
      try {
        await axios
          .put(
            `${BASE_PATH}/api/vfunlounge/profile`,
            {
              user_profile_key: userProfileKey,
              user_nick_name: inputValue.nickName,
              user_profile_image_url:
                url.profile !== "" ? url.profile : props.data?.profile,
              user_profile_background_image_url:
                url.profile_background !== ""
                  ? url.profile_background
                  : props.data?.profile_background,
              user_profile_desc: inputValue.desc
            },
            {
              headers: {
                ...headers
              }
            }
          )
          .then((res) => {
            if (res.data.result === 1) {
              alert("마이 프로필이 수정되었습니다.");
              setIsCreateProfilePop(false);
              setUserNickName(inputValue.nickName);
              setUserProfileImg(
                url.profile !== "" ? url.profile : props.data?.profile || ""
              );
            } else {
              alert("다시 시도해주세요sㄴㄴs");
            }
          });
      } catch (error) {
        console.log(error, "profileApi put");
      }
    }
  };

  const checkFileSize = (file: FileList | null) => {
    if (file !== null && file[0].size > 2000000) {
      alert(` 용량 초과`);
      return true;
    }
    return false;
  };

  const checkFileType = (file: FileList | null) => {
    if (file !== null && !allowedTypes.includes(file[0].type)) {
      alert("허용되지 않는 파일 타입");
      return true;
    }
    return false;
  };

  const onClickSave = async () => {
    if (
      checkFileSize(imgFile.profile) ||
      checkFileSize(imgFile.profile_background)
    ) {
      return;
    }

    if (
      checkFileType(imgFile.profile) ||
      checkFileType(imgFile.profile_background)
    ) {
      return;
    }

    try {
      await uploadImg("profile");
      await uploadImg("profile_background");
    } catch (error) {
      console.log(error, "onClickSave");
    }

    uploadInfo();
  };

  const onClickCancle = () => {
    if (props.type === 2) {
      navigate(-1);
    }
    setIsCreateProfilePop(false);
  };

  return (
    <PopUp title="마이 라운지 생성" id="createPop">
      <div className="box">
        <div className="row center">
          <OptionTitle option="라운지 닉네임" isEssential={true} />
          <input
            type="text"
            maxLength={12}
            value={inputValue.nickName || ""}
            autoFocus={true}
            name="nickName"
            placeholder="닉네임을 입력하세요"
            onChange={onValueChange}
            readOnly={isValid.passNickname}
          />
          <button
            onClick={onClickNickNameCheckBtn}
            className={`${isValid.passNickname ? "not" : ""} btn`}
          >
            {!isValid.passNickname ? (
              !isNicknameLoading ? (
                "중복확인"
              ) : (
                <FontAwesomeIcon icon={faSpinner} pulse />
              )
            ) : (
              <FontAwesomeIcon icon={faCheck} />
            )}
          </button>
        </div>
      </div>

      <div className="box row">
        <OptionTitle option="프로필 이미지" isEssential={false} />
        <div className="box-cont">
          <div>
            <label htmlFor="profile-img">
              <span className="btn">파일 선택</span>
              <span className="file-name ellipsis">
                {imgFile.profile === null
                  ? "선택된 파일 없음"
                  : imgFile.profile[0].name}
              </span>
            </label>
            <input
              type="file"
              accept=".gif, .jpg, .png, .bmp"
              multiple={false}
              name="profile"
              id="profile-img"
              onChange={handleAddImg}
              disabled={isuploadLoading}
            />
            <ValidTxt text="이미지는 2MB 이내의 JPG, GIF, PNG파일만 가능하며 일부 브라우저에서는 미리보기 기능이 지원되지 않을 수 있습니다." />
            <p className="size">사이즈는180*180 입니다.</p>
          </div>
          <div className="img-box">
            {imgBase64.profile !== "" && <img src={imgBase64.profile} />}
          </div>
        </div>
      </div>

      <div className="box row">
        <OptionTitle option="프로필 배경" isEssential={false} />
        <div className="box-cont">
          <div>
            <label htmlFor="profile-background-img">
              <span className="btn">파일 선택</span>
              <span className="file-name ellipsis">
                {imgFile.profile_background === null
                  ? "선택된 파일 없음"
                  : imgFile.profile_background[0].name}
              </span>
            </label>
            <input
              type="file"
              accept=".gif, .jpg, .png, .bmp"
              multiple={false}
              name="profile_background"
              id="profile-background-img"
              onChange={handleAddImg}
              disabled={isuploadLoading}
            />
            <ValidTxt text="이미지는 2MB 이내의 JPG, GIF, PNG파일만 가능하며 일부 브라우저에서는 미리보기 기능이 지원되지 않을 수 있습니다." />
            <p className="size">사이즈는 1200*200 입니다.</p>
          </div>
          <div className="img-box profile-background">
            {imgBase64.profile_background !== "" && (
              <img src={imgBase64.profile_background} />
            )}
          </div>
        </div>
      </div>
      <div className="box row">
        <OptionTitle option="프로필 설명" isEssential={false} />
        <textarea
          className="desc"
          maxLength={200}
          value={inputValue.desc}
          name="desc"
          onChange={onValueChange}
        />
      </div>

      <div className="btns">
        <button onClick={onClickSave}>
          {props.type === 2 ? "저장" : "수정"}
        </button>
        <button onClick={onClickCancle}>취소</button>
      </div>

      {isuploadLoading && <WrapLoading />}
    </PopUp>
  );
}

export default CreateProfilePopUp;
